<template>
  <div
    :id="this.id"
    @contextmenu.prevent="handler($event)"
    class="sitebuilder-element-container"
    element="TimerComponent"
    :data-hide-desktop="!this.config.showDesktop"
    :data-hide-mobile="!this.config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    :style="style()"
    v-on:click="focusElement($event)"
  >
    <div :class="{'vdr rotate-target': this.device == 'desktop'}" ref="target">
      <rotate :target="this.$refs.target" :config="this.internal_config" />
      <sync-drag :target="this" />
      <!-- <vue-draggable-resizable  :draggable="true"> -->
      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-TimerComponent'>
        <img src="static/images/icons/link.svg"
            v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
            class="svg-icon normal-action"
            @click="linkElement"/>
      </options-element-bar>

      <flip-clock v-if="this.internal_config.theme === 'panels' && this.internal_config" :preview="preview" :config="this.internal_config" :device="device"
                  @updateData="updateData"/>
      <time-circles ref="timecirlces" v-else-if="this.internal_config.theme === 'circles' && this.internal_config" @updateData="updateData"
                    @setCallbackChangeDevice="setCallbackChangeDevice" :preview="preview"
                    :options="this.internal_config.options" :config="this.internal_config"/>
      <time-show ref="timeshow" v-else-if="this.internal_config.theme" :preview="preview" @updateData="updateData"
                @setCallbackChangeDevice="setCallbackChangeDevice" :options="this.internal_config.options"
                :config="this.internal_config"/>

      <resources ref="resourcesData"></resources>
      <!-- </vue-draggable-resizable> -->
    </div>
  </div>
</template>

<script>
import Data from './Model';
import XDate from 'xdate';
import ApplyConfig from './ApplyConfig';
import Resources from './Resources.vue';
import FlipClock from './FlipClock/FlipClock.vue';
import TimeCircles from './TimeCircles/TimeCircles';
import TimeShow from './TimeShow/TimeShow';
import OptionsElementBar from '../OptionsElementBar';

export default {
  name: 'TimerComponent',
  props: ['config', 'id', 'preview'],
  components: {
    OptionsElementBar,
    Resources,
    FlipClock,
    TimeCircles,
    TimeShow
  },
  computed: {
    device() {
      let el = document.querySelector('.cheetah-editor');
      return el ? el.dataset['device'] : null;
    }
  },
  data() {
    return Data.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },
  methods: {
    /**
     * Default actions - Begin
    */
    animation() {
      return true;
    },

    linkElement: function() {
      this.$root.$emit('linkComponentShow', this);
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },

    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    build(config) {
      this.internal_config = window.mergeRecursive(this.props, config);
      this.$refs.resourcesData.setValuesData(this);
    },

    style() {
      return `left:  ${this.internal_config.left};
              z-index: ${this.internal_config.zIndex};
              max-width: ${this.internal_config.maxWidth};
              margin: 0 auto;
              top: ${this.internal_config.top}`;
    },

    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);
      e.stopPropagation();
      e.preventDefault();
    },

    setCallbackChangeDevice(values) {
      this.$emit('setCallbackChangeDevice', values);
    },
    /**
    * Default actions - End
    */
    rebuild() {
      let vm = this;
      let config = this.internal_config;
      this.$nextTick(() => {
        this.internal_config = {};
        vm.internal_config = Object.assign({}, vm.internal_config, config);
        this.$root.$emit('rSidebarEdition', vm);
      });
    },

    updateData() {
      let applyConfig = new ApplyConfig(this);
      this.internal_config = applyConfig.treatment();
    },

    getSumDate(config, gmt) {
      let date = gmt ? XDate(true) : XDate();

      return date
        .addDays(config.days)
        .addHours(config.hours)
        .addMinutes(config.minutes)
        .addSeconds(config.seconds)
        .toString();
    },

    getOriginalDateFinish() {

      var now = XDate().toString();
      var gtm = now.substr(now.indexOf('GMT'), 8);

      this.internal_config.settings.gmt_save = gtm;

      switch (this.internal_config.type) {
        case 'decrease_date_end': // Até Data Especifica

          this.internal_config.settings.original_date_finish = XDate(XDate(this.internal_config.date_end))
            .addHours(this.internal_config.settings.original_hours_finish)
            .addMinutes(this.internal_config.settings.original_minutes_finish)
            .toString();

          let date = XDate();
          let dateGTM0 = XDate(true);

          let diffSecondsTotal = XDate(dateGTM0).diffSeconds(XDate(date));

          this.internal_config.settings.original_date_finish_gmt0 = XDate(this.internal_config.settings.original_date_finish).addSeconds(diffSecondsTotal * (-1)).toString();

          break;

        case 'decrease_sum_time': // Contas até intervalo de Horas
          if (typeof this.internal_config.settings.save_time === 'undefined') {
            this.internal_config.settings.save_time = XDate().toString();
          }

          this.internal_config.settings.original_date_finish = this.getSumDate(this.internal_config, false);
          this.internal_config.settings.original_date_finish_gmt0 = this.getSumDate(this.internal_config, true);
          break;

        case 'decrease_sum_time_user_start': // Evergreen
        case 'start_user_every_access': // Contar tempo em todo acesso do usuario
          if (typeof this.internal_config.settings.save_time === 'undefined') {
            this.internal_config.settings.save_time = XDate().toString();
            this.internal_config.settings.original_date_finish_gmt0 = XDate(true).toString();
          }
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.build(this.$props.config);

    if (!this.internal_config.settings.original_date_finish && this.internal_config.settings.original_date_finish === 0) { this.getOriginalDateFinish() }

    var isEditor = document.querySelectorAll('.panel-components-right').length > 0;

    let applyConfig = new ApplyConfig(this);
    this.internal_config = applyConfig.treatment();

    if (!isEditor) {
      let values = applyConfig.build();
      this.internal_config.settings = {...this.internal_config.settings, ...values};
    }

    this.internal_config = window.mergeRecursive(this.props, this.$props.config);

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

      this.$el.classList.add('preview');
    }

    let objIds = [];
    $('[id]').each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id)) { objIds.push(this.id) }
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on('setConfigElement', (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$forceUpdate();
  }
};
</script>

<style scoped lang="scss" scoped>
  .flip-clock-wrapper ul li a div div.inn {
    background: #333 !important;
  }

  [element=TimerComponent].widget-focused {
    // outline: 2px solid #007bff !important;

    .default-options {
      display: inline-flex;
      position: absolute;
      top: -26px;
      font-size: 12px;
      color: #007bff;
      padding: 3px;
      background-color: white;
      border: 1px solid blue;
      z-index: 12;

      .font-awesome-icon {
        padding-left: 5px;
      }
    }
  }

  .rotate-target {
    position: absolute;
    top: 0px;
    left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Timer/Timer.vue